import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faSyncAlt } from '@fortawesome/free-solid-svg-icons';
import user from '../../services/user-auth';
import UserRole from '../../enumerables/user-role';
interface Props {
    event: any;
    slotStart?: any;
    deleteCell: (id: string | number) => void;
}

const ModalEvent: React.FunctionComponent<Props> = (props: Props) => {
    const { event, deleteCell } = props;
    const isMobile = window.innerWidth <= 800;
    const isSupervisor = user.getSupervisor();
    const isProvider = !user.getRoles().includes(UserRole.ROLE_ADMIN) && !isSupervisor;
    const isAdmin = user.getRoles().includes(UserRole.ROLE_ADMIN);
    const isNotAllowChangeDate = !isAdmin && event?.hasPaid;
    const disabled: boolean = (!!isProvider && !!event.status && !!(+event.status === 4)) || !!isNotAllowChangeDate;

    console.log(event);
    return (
        <span className={`d-flex flex-wrap  flex-column position-relative justify-content-between`}>
            {!isMobile ? (
                <div>
                    {' '}
                    <div style={{ paddingRight: '10px', fontSize: 12 }}>
                        Case #{event.occasion} {event.isWeekly ? <FontAwesomeIcon icon={faSyncAlt} /> : null}
                    </div>
                    <div style={{ paddingRight: '10px', fontSize: 12 }}>Name: {event.name}</div>
                    <div style={{ paddingRight: '10px', fontSize: 12 }}>Provider: {event.provider}</div>
                    <div style={{ paddingRight: '10px', fontSize: 12 }}>id: {event.id}</div>
                </div>
            ) : (
                <div style={{ position: 'relative', width: '100%' }}>
                    <div className={'cellCalendar'} style={{ fontSize: 13 }}>
                        {event.name}
                    </div>
                    {event.isWeekly ? <FontAwesomeIcon className={'iconWeeklyCell'} icon={faSyncAlt} /> : null}
                </div>
            )}

            {!isMobile && event.status !== 5 && !disabled && event.canEditSession != 0 ? (
                <button
                    style={{
                        position: 'absolute',
                        right: '0',

                        background: 'transparent',
                        border: 'none',
                    }}
                    className={'btnEventDelete'}
                    onClick={(ev) => {
                        ev.stopPropagation();
                        deleteCell(event.id);
                    }}
                >
                    <FontAwesomeIcon icon={faTimes} />
                </button>
            ) : null}
        </span>
    );
};

export default ModalEvent;
